import { render, staticRenderFns } from "./message-input-button.vue?vue&type=template&id=0bd30c04&scoped=true"
import script from "./message-input-button.vue?vue&type=script&lang=ts"
export * from "./message-input-button.vue?vue&type=script&lang=ts"
import style0 from "./message-input-button.vue?vue&type=style&index=0&id=0bd30c04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd30c04",
  null
  
)

export default component.exports